import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import "@/styles/common/index.less";
import "./styles/components.less";
import "./styles/fix.less";
import "@/styles/iconfont/iconfont.css";
import "./styles/light.scss";
import Vant from "vant";
import "vant/lib/index.css";
import axios from "./plugins/axios";
import MMIcon from "@/components/MMIcon.vue";
import "@/styles/iconfont/iconfont.css";
import "@/styles/iconfont/iconfont.js";
import { getCookie } from "./utils";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

router.beforeEach(async (to, from, next) => {
  store.commit("user/SAVE_AUTH_TOKEN", {
    token: getCookie("auth_token") || "",
  });
  const auth_token = store.state.user.auth_token;

  // 不同平台切换账号token存在但是不相同，getUserInfo刷新信息
  const lastToken = localStorage.getItem("lastToken");
  if (!(lastToken === auth_token) && auth_token && lastToken) {
    localStorage.setItem("lastToken", auth_token);
    await store.dispatch("user/getUserInfo");
  } else {
    localStorage.setItem("lastToken", auth_token);
  }
  if (to.query.ch) {
    localStorage.setItem("channel_no", to.query.ch as string);
    next(to.path);
  }
  const whiteList = ["/home", "/mobile-tip", "/h5Home"];
  if (whiteList.includes(to.fullPath)) {
    next();
  } else {
    if (auth_token) {
      const userInfo = store.state.user.userInfo;
      if (!userInfo || !Object.keys(userInfo).length) {
        await store.dispatch("user/getUserInfo");
      } else {
        store.commit("user/SAVE_AUTH_TOKEN", { token: auth_token });
      }

      if (store.getters["user/isReject"]) {
        if (to.path !== "/home") {
          next("/home");
        }
      }
    } else {
      store.dispatch("user/logout", false);
      if (to.path == "/home") {
        next();
      } else {
        next("/home");
      }
    }
  }

  next();
});

const app = createApp(App);
app
  .component("mm-icon", MMIcon)
  .use(Antd)
  .use(Vant)
  .use(store)
  .use(router)
  .use({
    install(res) {
      res.config.globalProperties.$axios = axios;
    },
  })
  .mount("#app");

// Sentry.init({
//   app,
//   dsn: "https://ff1ed1b218184d7aab011d917cef845c@o4504138068918272.ingest.sentry.io/4504353512816640",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracePropagationTargets: ["developer.metamaker.cn", /^\//],
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });
